import clsx from 'clsx';
import { BookmarkSquareIcon } from '@heroicons/react/24/outline';
import { SavedSearch } from '../../../../../../components/ProfileArea/types';

interface SavedColumnsPanelContentProps {
  isAuthenticated: boolean;
  savedColumns: SavedSearch[];
  activeSavedColumnsId: string | null;
  setActiveSavedColumnsId: (id: string) => void;
  onApplySavedColumns?: (columns: any) => void;
}

export function SavedColumnsPanelContent({
  isAuthenticated,
  savedColumns,
  activeSavedColumnsId,
  setActiveSavedColumnsId,
  onApplySavedColumns,
}: SavedColumnsPanelContentProps) {
  if (!isAuthenticated) {
    return (
      <p className="px-4 py-2 text-sm text-gray-500 break-words">
        <a href="/login">Sign in</a> to see your saved columns.
      </p>
    );
  }

  if (!savedColumns.length) {
    return <p className="px-4 py-2 text-sm text-gray-500 break-words">No saved columns yet.</p>;
  }

  return (
    <ul className="space-y-2 py-1 min-w-0 px-1">
      {savedColumns.map(savedColumn => {
        const visibleCount = Object.values(savedColumn.columnVisibilityModel ?? {}).filter(Boolean).length;
        const isActive = activeSavedColumnsId === savedColumn.id;
        return (
          <li key={savedColumn.id} className="min-w-0">
            <button
              type="button"
              onClick={() => {
                setActiveSavedColumnsId(savedColumn.id);
                onApplySavedColumns?.(savedColumn);
              }}
              className={clsx(
                'w-full rounded-xl border px-3 py-2 text-left transition-colors',
                isActive
                  ? 'border-[#be0080] bg-[#FFE7F5] shadow-[0_0_0_1px_rgba(236,42,153,0.18)]'
                  : 'border-[#F1BCD8] bg-[#FFF7FC] hover:bg-[#FFF0F8]',
              )}
            >
              <div className="flex items-start gap-2">
                <BookmarkSquareIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-pink" />
                <div className="min-w-0 flex-1">
                  <p className="m-0 truncate text-xs font-semibold text-gray-900">{savedColumn.name}</p>
                  <p className="m-0 truncate text-xs text-[#6A7894]">
                    {visibleCount} column{visibleCount === 1 ? '' : 's'}
                  </p>
                </div>
                {isActive && (
                  <span className="shrink-0 rounded-md bg-[#FFE2F2] px-2 py-0.5 text-xs font-semibold uppercase tracking-wide text-[#be0080]">
                    Active
                  </span>
                )}
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
